import { create } from "zustand";
import { persist } from "zustand/middleware";

import { SearchQueryRequestedPage } from "types/generated";
import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";

type IntentProjectOperationsStore = {
  rowsPerPage: number;
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
};

const useIntentProjectOperationsStore = create<IntentProjectOperationsStore>()(
  persist(
    (set) => ({
      rowsPerPage: 50,
      cursor: null,
      requestedPage: SearchQueryRequestedPage.First,
      onFetchItems: (props: UsePaginationFetchMoreProps) =>
        set({ cursor: props.cursor, requestedPage: props.requestedPage }),
    }),
    {
      name: "intent-project-operations-store",
      partialize: (state) => ({
        rowsPerPage: state.rowsPerPage,
      }),
    }
  )
);

export default useIntentProjectOperationsStore;
